import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "../../redux-store";
import { GameStatus } from "../../redux-store/slices/game/game.interfaces";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { EventTypes } from "../../redux-store/slices/events/events.interfaces";

export const useFeedbackDialog = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  const status = useSelector(selectors.getGameStatus);
  const chosenLevel = useSelector(selectors.getChosenLevel);

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const feedbackColor = useMemo(() => {
    if (status === GameStatus.SUCCESS) {
      return "tertiary.light";
    } else return "primary";
  }, [status]);

  const gameEnded = useMemo(
    () => status === GameStatus.SUCCESS || status === GameStatus.FAIL,
    [status],
  );
  const isWin = useMemo(() => status === GameStatus.SUCCESS, [status]);

  const onDiscoverMoreButtonClicked = useCallback(() => {
    const link = chosenLevel.successDialogContent.link;
    dispatch(
      actions.dispatchEvent({
        eventType: EventTypes.QUIZ_LINK,
        extraData: { quizLink: link, quizStepName: chosenLevel.name },
      }),
    );
    window.open(link, "_blank");
  }, [dispatch, chosenLevel]);

  useEffect(() => {
    if (gameEnded && !isDialogOpen) {
      setTimeout(() => {
        setIsDialogOpen(true);
      }, 1500);
    }
  }, [gameEnded, isDialogOpen]);

  const dialogActionsDirection = useMemo<
    "column" | "column-reverse" | "row" | "row-reverse"
  >(() => {
    if (isMobile) {
      return isWin ? "column" : "column-reverse";
    } else {
      return isWin ? "row" : "row-reverse";
    }
  }, [isMobile, isWin]);

  return {
    isDialogOpen,
    isWin,
    chosenLevel,
    isMobile,
    feedbackColor,
    onDiscoverMoreButtonClicked,
    dialogActionsDirection,
  };
};
